import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";
import { UseFormWatch } from "react-hook-form";

import {
  EligibilityBox,
  IconFaInfoAlt,
  NavLine,
  priorAuthHeader,
  StageCircle,
  StatusContainer,
  StickyContainer,
} from "../../../styles/styles";
import fontWeight from "../../../../styles/mui/fontWeight";
import colors from "../../../../styles/colors/colors";
import PatientDetails from "./PatientDetails";
import {
  flexAlignCentre,
  flexRowCenter,
} from "../../../../styles/mui/styles/display";
import { EligibilityInformation } from "../../../../models/CheckEligibility";

export interface PropsFromState {
  watch: UseFormWatch<any>;
  eligibilityData: EligibilityInformation | null;
}
type AllProps = PropsFromState;

const PatientInfo: React.FC<any> = ({
  watch,
  eligibilityData
}: AllProps) => {
  return (
    <>
      <Grid container sx={priorAuthHeader}>
        <Grid size={4}>
          <Grid container sx={flexAlignCentre}>
            <Typography
              variant="subtitle1"
              textAlign="center"
              pl={"1.5rem"}
              fontWeight={fontWeight.Weight[6]}
              color={colors.black[2]}
            >
              PRIOR AUTHORIZATION FORM
            </Typography>
          </Grid>
        </Grid>
        <Grid size={8} sx={StatusContainer}>
          <Grid container gap={"1rem"}>
            <Grid sx={flexRowCenter}>
              <Box mr={"0.5rem"} sx={EligibilityBox}>
                <IconFaInfoAlt />
              </Box>
              <Typography
                variant="subtitle2"
                fontWeight={fontWeight.Weight[3]}
                color={colors.black[2]}
              >
                CHECK ELIGIBILITY
              </Typography>
            </Grid>
            <Grid sx={flexRowCenter}>
              <Box sx={NavLine}></Box>
            </Grid>
            <Grid sx={flexRowCenter}>
              <Box mr={"0.5rem"} sx={StageCircle}>
                <Typography
                  variant="h6"
                  fontWeight={fontWeight.Weight[4]}
                  color={colors.black[2]}
                  pt={"0.25rem"}
                >
                  2
                </Typography>
              </Box>
              <Typography
                variant="subtitle2"
                textAlign="center"
                fontWeight={fontWeight.Weight[5]}
                color={colors.black[2]}
              >
                REFERRAL DETAILS
              </Typography>
            </Grid>{" "}
          </Grid>
        </Grid>
      </Grid>
      <Grid container sx={StickyContainer}>
        <PatientDetails
          watch={watch}
          eligibilityData={eligibilityData}
        />
      </Grid>
    </>
  );
};

export default PatientInfo;
